import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import LazyLoad from 'react-lazyload';
import Image from './../dom-elements/Image';
import ProjectDetailCaption from './../ProjectDetailCaption';
import Popover from '../popover/Popover';
import GridItemMobile from './GridItemMobile';
import { photoArray, returnOpacity } from './../../scripts';
import { breakpoints } from './../../styles/theme.json';

class FlexiblePortfolioLayout extends Component {
  constructor(props) {
    super(props);
    this.closePopup = this._closePopup.bind(this);
    this.state = {
      popover: false,
      currentImage: null,
      thumbClicked: null,
      clicks: 0
    };
    this.mobileClickHandler = this.mobileClickHandler.bind(this);
  }

  mobileClickHandler(id) {
    this.setState({
      popover: true,
      currentImage: id
    });
  }

  _clickPopupDesktop(id) {
    this.setState({
      currentImage: id,
      popover: true
    });
  }

  _clickPopupMobile(id, buttonId) {
    if (this.state.clicks == 0 || this.state.clicks == 1 && buttonId != this.state.thumbClicked ) {
      this.setState({
        thumbClicked: buttonId,
        clicks: 1
      });
    } else if (this.state.clicks == 1 && buttonId == this.state.thumbClicked) {
      this.setState({
        popover: true,
        currentImage: id,
        clicks: 0,
        thumbClicked: null
      });
    }
  }

  _closePopup() {
    this.setState({
      popover: false
    });
  }

  render() {
    const GridItemDesk = (props) => (
      <div className={'flexible-image-wrapper'} onClick={() => this._clickPopupDesktop(props.ImgData.image.urls.id)}>
        <LazyLoad height='100%'>
          <ProjectDetailCaption
            ProjectName={props.ImgData.image.metadata.title}
            ImageDescription={props.ImgData.image.metadata.caption}
            ExpandIcon={true}
          />
          <div className={'image-inner'}>
            <div className={'gradient-wrapper'}>
              <div className={'bg-gradient'} style={{ opacity: returnOpacity(props.ImgData.image.gradient_opacity) }}/>
            </div>
            {(props.ImgSize == 'full_row')
              ? <Image source={props.ImgData.image.urls.large}/> :
              (props.ImgSize == 'full_bleed')
              ? <Image source={props.ImgData.image.urls.large}/>
              : <Image source={props.ImgData.image.urls.small}/>
            }
          </div>
        </LazyLoad>
      </div>
    );
    const FlexLayoutDesk = photoArray(this.props.LayoutItems).flex_array.map((item, i) =>
      <li className={'flexible-row'} key={'flex-layout-item-desk' + i}>
        {(item.two_column)
          ? <div className={'two_column flex-row-wrapper'}>
              <GridItemDesk ImgData={item.two_column[0]} ImgSize={'two_column'}/>
              <GridItemDesk ImgData={item.two_column[1]} ImgSize={'two_column'}/>
            </div>
          :
          (item.image)
          ? <div className={item.image.position + ' flex-row-wrapper'}>
              <GridItemDesk ImgData={item} ImgSize={item.image.position}/>
            </div>
          : null
        }
      </li>
    );
    const FlexLayoutMobile = photoArray(this.props.LayoutItems).carousel_array.map((item, i) =>
      <li className={'flexible-row'} key={'flex-layout-item-mobile' + i}>
        <div className={item.position + ' flex-row-wrapper'}>
          <GridItemMobile clickFunction={this.mobileClickHandler} ImgData={item} Index={i}/>
        </div>
      </li>
    );
    return (
      <section id="flexible-layout">
        {(this.state.popover) &&
          <Popover Images={photoArray(this.props.LayoutItems).carousel_array} CurrentImage={this.state.currentImage} ClickFunction={() => this.closePopup()}/>
        }
        {(this.props.window_width >= breakpoints.desktop)
          ? <ul id="layout">
              {FlexLayoutDesk}
            </ul>
          : <ul id="layout">
              {FlexLayoutMobile}
            </ul>
        }
      </section>
    );
  };
};

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(FlexiblePortfolioLayout);



// WEBPACK FOOTER //
// ./src/components/photo-film-project/FlexiblePortfolioLayout.js